// replace the user pool region, id, and app client id details
export default {
    "REGION": "east-1",
    "USER_POOL_ID": "us-east-1_fD5vKZnUp",
    "USER_POOL_APP_CLIENT_ID": "6p2ubmde7706pe60638mv53q31",
}